export default function ScanMemberIcon() {
  return (
    <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32 15L32 13.5C32 12.105 32 11.4076 31.8467 10.8353C31.4306 9.2824 30.2176 8.06944 28.6647 7.65333C28.0924 7.5 27.395 7.5 26 7.5"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M5 15L5 13.5C5 12.105 5 11.4076 5.15333 10.8353C5.56944 9.2824 6.7824 8.06944 8.33531 7.65333C8.90756 7.5 9.60504 7.5 11 7.5"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M32 21L32 22.5C32 23.895 32 24.5924 31.8467 25.1647C31.4306 26.7176 30.2176 27.9306 28.6647 28.3467C28.0924 28.5 27.395 28.5 26 28.5"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M5 21L5 22.5C5 23.895 5 24.5924 5.15333 25.1647C5.56944 26.7176 6.7824 27.9306 8.33531 28.3467C8.90756 28.5 9.60504 28.5 11 28.5"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path d="M18.5 22.5L18.5 13.5" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12.5 21L12.5 15" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M24.5 21L24.5 15" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
